// src/utils/storage.js

/**
 * Retrieves the JWT token from localStorage.
 * @returns {string|null} - JWT token or null if not found.
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Saves the JWT token to localStorage.
 * @param {string} token - JWT token to save.
 */
export const setToken = (token) => {
  localStorage.setItem('token', token);
};

/**
 * Removes the JWT token from localStorage.
 */
export const removeToken = () => {
  localStorage.removeItem('token');
};
